import React from 'react';
import PropTypes from 'prop-types';
import { getFares } from '../../../_integrations/everymundo/carPackage';
import FaresGridBackgroundImage from '../FaresGridBackgroundImage';

const FlightsCarsPackagesGridContainer = (props) => (
  <FaresGridBackgroundImage {...props} getFares={getFares} />
);

FlightsCarsPackagesGridContainer.componentName = 'FlightsCarsPackagesGridContainer';

FlightsCarsPackagesGridContainer.propTypes = {
  /**
   * Parameters tracking
   */
  tracking: PropTypes.objectOf(PropTypes.any)
};

FlightsCarsPackagesGridContainer.defaultProps = {
  tracking: {
    flexibleDates: false,
    passengerCount: 1,
    promoCode: 'EVERYMUNDO',
    eventType: 'flightsCarsPackagesGridContainer'
  }
};

export default FlightsCarsPackagesGridContainer;
